import { useQuery } from '@tanstack/react-query'
import {
  getDirectOfferInfoForBuyer,
  getDirectOfferInfoForBuyerKey,
  getDirectOfferInfoForSeller,
  getDirectOfferInfoForSellerKey,
} from '../../api-client/listing'
import { useAuth } from '../../contexts/auth'

export default function useNegotiationInfo({
  forBuyer,
  directOfferId,
  vehicleId,
  buyNowListingId,
  config = {},
}) {
  const [{ isAuthenticated }] = useAuth()

  const queryForBuyer = useQuery({
    queryKey: [getDirectOfferInfoForBuyerKey, vehicleId],
    queryFn: () => getDirectOfferInfoForBuyer({ vehicleId }),
    enabled: !!forBuyer && !!buyNowListingId && isAuthenticated,
    ...config,
  })

  const queryForSeller = useQuery({
    queryKey: [getDirectOfferInfoForSellerKey, directOfferId],
    queryFn: () => getDirectOfferInfoForSeller({ directOfferId }),
    enabled: !forBuyer && !!buyNowListingId && isAuthenticated,
    ...config,
  })

  return forBuyer ? queryForBuyer : queryForSeller
}
